import { metersBetween } from "../shared/parking";

/** A GPS fix: `at` in ms; `speed` is the device's own estimate in m/s (null when it has none). */
export interface Fix {
  lat: number;
  lng: number;
  at: number;
  speed?: number | null;
}

/** Below this, GPS jitter: the rider is standing still. */
const STILL_KMH = 3;

/** Speed in km/h between two fixes: the device's when given, else distance over time. */
export function kmhFrom(prev: Fix | undefined, next: Fix): number {
  let kmh: number;
  if (typeof next.speed === "number" && next.speed >= 0) kmh = next.speed * 3.6;
  else {
    if (!prev || next.at - prev.at < 1000) return 0;
    kmh = (metersBetween(prev, next) / ((next.at - prev.at) / 1000)) * 3.6;
  }
  return kmh < STILL_KMH ? 0 : Math.round(kmh);
}
